<app-custom-select [iconClass]="'text-indent-left fw-bold'" [options]="rolesList" [(ngModel)]="localValue"
  [title]="title" (ngModelChange)="onValueChange($event)" [isDisabled]="isDisabled"></app-custom-select>
